/**
 * ActionEmpty - Empty state component for action renderers.
 *
 * Displays when an action is null or undefined.
 */

import type { RenderMode } from '../../../lib/proposals/registry';

interface ActionEmptyProps {
  mode?: RenderMode;
  className?: string;
  message?: string;
}

/**
 * Empty state display for action renderers.
 * Shown when there's no action data to display.
 */
export function ActionEmpty({
  mode = 'full',
  className = '',
  message = 'No action to display',
}: ActionEmptyProps) {
  // Inline mode - minimal empty display
  if (mode === 'inline') {
    return <span className={`text-fg-tertiary text-sm ${className}`}>—</span>;
  }

  // Compact mode - short message
  if (mode === 'compact') {
    return (
      <span className={`text-sm text-fg-tertiary ${className}`}>{message}</span>
    );
  }

  // Header mode - styled for accordion headers
  if (mode === 'header') {
    return (
      <span className={`text-sm text-fg-tertiary ${className}`}>{message}</span>
    );
  }

  // Full/readonly mode - complete empty state card
  return (
    <div
      className={`border border-border-secondary rounded-md bg-bg-secondary p-6 text-center ${className}`}
    >
      <p className='text-sm text-fg-tertiary'>{message}</p>
    </div>
  );
}
